import { c as _c } from "react/compiler-runtime";
import { type MintCountdownState, useMintCountdownState } from "@/hooks/useMintCountdownState";
import NowMintingCountdownActive from "./NowMintingCountdownActive";
import NowMintingCountdownLoading from "./NowMintingCountdownLoading";
import NowMintingCountdownStatus from "./NowMintingCountdownStatus";
interface NowMintingCountdownProps {
  readonly nftId: number;
  readonly contract: string;
  readonly chainId: number;
  readonly hideMintBtn?: boolean;
  readonly hideNextDrop?: boolean;
  readonly fullWidth?: boolean;
}
export default function NowMintingCountdown(t0) {
  const $ = _c(12);
  const {
    nftId,
    contract,
    chainId,
    hideMintBtn,
    hideNextDrop,
    fullWidth
  } = t0;
  let t1;
  if ($[0] !== chainId || $[1] !== contract || $[2] !== hideMintBtn) {
    t1 = {
      contract,
      chainId,
      hideMintBtn
    };
    $[0] = chainId;
    $[1] = contract;
    $[2] = hideMintBtn;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const state = useMintCountdownState(nftId, t1);
  const t2 = `tw-group tw-relative tw-mt-auto ${fullWidth ? "tw-w-full" : ""}`;
  let t3;
  if ($[4] !== hideNextDrop) {
    t3 = hideNextDrop !== undefined && {
      hideNextDrop
    };
    $[4] = hideNextDrop;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== state || $[7] !== t3) {
    t4 = <NowMintingCountdownContent state={state} {...t3} />;
    $[6] = state;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function NowMintingCountdownContent(t0) {
  const $ = _c(8);
  const {
    state,
    hideNextDrop
  } = t0;
  switch (state.type) {
    case "loading":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <NowMintingCountdownLoading />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "error":
    case "sold_out":
    case "finalized":
      {
        let t1;
        if ($[1] !== hideNextDrop) {
          t1 = hideNextDrop !== undefined && {
            hideNextDrop
          };
          $[1] = hideNextDrop;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        let t2;
        if ($[3] !== state.type || $[4] !== t1) {
          t2 = <NowMintingCountdownStatus type={state.type} {...t1} />;
          $[3] = state.type;
          $[4] = t1;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        return t2;
      }
    case "countdown":
      {
        let t1;
        if ($[6] !== state.countdown) {
          t1 = <NowMintingCountdownActive countdown={state.countdown} />;
          $[6] = state.countdown;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
  }
}